export default "__VITE_ASSET__B72aNn5g__"